import React, { Component } from 'react';
import { giveRandomNumber } from '@bit/gerenciatd.utils.common';
import { sendCMSEvent } from '@bit/gerenciatd.utils.metrics';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './Select.scss';

/**
 * Stateless component to draw a Select
 * @param {string} id identificador
 * @param {string} name name prop of the select tag
 * @param {array} options array of select options (object value and label)
 * @param {object} defaultValue Default value of the select (object value and label)
 * @param {function} onChange This function is executed when select change, and rise up the new value to its parent
 * @param {bool} isSearchable (opcional) flag para decir si se puede buscar o no
 * @param {bool} forcedDisabled (opcional) flag para forzar el modo des-habilitado
 * @param {obj} taggingInfo info de taggueo
 * @returns {JSX} Component JSX.
 */
const fusionSelect = ({
  options, defaultValue, id, onChange, taggingInfo, name, isSearchable, forcedDisabled,
}) => {
  let finalDOMId = id;
  if (!finalDOMId) {
    finalDOMId = `Select-${giveRandomNumber(1, 999)}`;
  }

  const finalTaggingInfo = {
    ...taggingInfo,
    eventType: 'click',
  }

  const handleChange = (selectedOption) => {
    onChange(selectedOption);
    const taggingInfoCompleted = {
      ...finalTaggingInfo,
    }
    if (!taggingInfoCompleted.componentContent) {
      taggingInfoCompleted.componentContent = `select-${selectedOption.label}`;
    }

    sendCMSEvent(taggingInfoCompleted);
  }
  const customStyles = {
    option: (provided, state) => ({// lista de opciones
      ...provided,
      color: state.isSelected ? 'white' : '#86888C',
    }),
    control: provided => ({// cajita que se muestra
      ...provided,
      color: '#019DF4',
      backgroundColor: 'white',
    }),
    singleValue: (provided, state) => ({// div del texto
      ...provided,
      color: '#019DF4',
      backgroundColor: 'white',
      opacity: state.isDisabled ? 0.5 : 1,
    }),
  }
  let claseEstado = '';
  if (forcedDisabled || options.length <= 1 ) {
    claseEstado = 'disabled';
  }
  return (
    <div className={claseEstado}>
      <Select
        options={options}
        id={finalDOMId}
        defaultValue={defaultValue}
        isSearchable={isSearchable}
        value={Array.isArray(name) ? defaultValue : name || defaultValue}
        onChange={handleChange}
        components={{
          IndicatorSeparator: () => null,
        }}
        className="fusionSelect"
        styles={customStyles}
        classNamePrefix="adios"
      />
    </div>
  );
}

fusionSelect.propTypes = {
  options: PropTypes.array.isRequired,
  defaultValue: PropTypes.object,
  onChange: PropTypes.func,
  taggingInfo: PropTypes.object.isRequired,
  isSearchable: PropTypes.bool,
  forcedDisabled: PropTypes.bool,
}

fusionSelect.defaultProps = {
  forcedDisabled: false,
  onChange: () => {},
  defaultValue: '',
  isSearchable: false,
}

export default fusionSelect;
